import api from "@/plugins/api/EntryPoint";

export default {
  getSettings(callBackFn) {
    api.get(`settings/user`, callBackFn);
  },
  storeSettings(settings) {
    return api.post(`settings/update`, settings);
  },
  storePhone(phone) {
    return api.post(`settings/add-phone`, { phone });
  },
  async getPhone(callBackFn) {
    await api.get(`settings/phone`, callBackFn);
  },
  putLanguage(language) {
    return api.put("settings/put-language", { language });
  },
  setTheme(theme) {
    return api.put("settings/set-theme", { theme });
  },
  getTheme(callBackFn) {
    return api.get(`settings/theme`, callBackFn);
  },
   getLanguage(callBackFn) {
    return api.get(`settings/language`, callBackFn);
  },
};
